export const home = {
  '@context': 'http://schema.org',
  '@type': 'Organization',
  '@id': 'https://www.sight-sound.com',
  name: 'Sight & Sound',
  telephone: '+18003771277',
  logo: 'https://www.sight-sound.com/assets/favicons/apple-icon-precomposed.png',
  legalName: 'Sight & Sound Ministries, Inc.',
  iso6523Code: [
    '0060:072831712',
    '0088:0852862004005',
    '0199:549300SG1H2QK8YRWN43',
  ],
  naics: '711110',
  sameAs: [
    'https://en.wikipedia.org/wiki/Sight_%26_Sound_Theatres',
    'https://www.facebook.com/sightsoundtheatreslancaster/',
    'https://www.youtube.com/user/sightsoundtheatres',
    'https://www.instagram.com/sightandsoundtheatres/',
    'https://shop.sight-sound.com/?_gl=1*5obtu8*_ga*MTM2MzMxNzcuMTcyMTkwOTE0NA..*_ga_K36R40SVHX*MTcyNTU0NTQzNi4zNC4xLjE3MjU1NDY5NzAuNTguMC4w',
    'https://www.sight-sound.tv/',
  ],
  url: 'https://www.sight-sound.com',
  image:
    'https://sst-prod.cdn.sight-sound.com/assets/da57919f-919d-429e-b1cc-884c3c5275a6?width=1200&quality=100&format=auto&modifiedDate=2024-07-02T17:43:54.130Z',
  description:
    'Sight & Sound is a storytelling company passionate about bringing true stories of redemption to life on stage and on screen that reveal the power of the Gospel.',
};

export const lancaster = {
  '@context': 'http://schema.org',
  '@type': 'EntertainmentBusiness',
  '@id': 'https://www.sight-sound.com/lancaster',
  name: 'Sight & Sound Theatres',
  hasMap: 'https://maps.app.goo.gl/2am72aATyiuh9LyD8',
  telephone: '+18003771277',
  url: 'https://www.sight-sound.com/lancaster',
  image:
    'https://sst-prod.cdn.sight-sound.com/assets/da57919f-919d-429e-b1cc-884c3c5275a6?width=1200&quality=100&format=auto&modifiedDate=2024-07-02T17:43:54.130Z',
  description:
    "Experience the Bible's most epic stories as they come to life on a panoramic stage! Sight & Sound Theatres offers unforgettable and uplifting shows.",
  address: {
    '@type': 'PostalAddress',
    streetAddress: '300 Hartman Bridge Rd',
    addressLocality: 'Ronks',
    addressRegion: 'PA',
    postalCode: '17572',
  },
  geo: {
    '@type': 'GeoCoordinates',
    latitude: 39.99812,
    longitude: -76.18832,
  },
};

export const branson = {
  '@context': 'http://schema.org',
  '@type': 'EntertainmentBusiness',
  '@id': 'https://www.sight-sound.com/lancaster',
  name: 'Sight & Sound Theatres',
  hasMap: 'https://maps.app.goo.gl/7Z8BfwTYtB3Va21i9',
  telephone: '+18003771277',
  url: 'https://www.sight-sound.com/branson',
  image:
    'https://sst-prod.cdn.sight-sound.com/assets/9a98bbb5-d0cb-40cc-ac28-6734460b701e?width=1920&quality=100&format=auto&modifiedDate=2024-07-02T17:41:28.033Z',
  description:
    "Experience the Bible's most epic stories as they come to life on a panoramic stage! Sight & Sound Theatres offers unforgettable and uplifting shows.",
  address: {
    '@type': 'PostalAddress',
    streetAddress: '1001 Shepherd of the Hills Expy',
    addressLocality: 'Branson',
    addressRegion: 'MO',
    postalCode: '65616',
  },
  geo: {
    '@type': 'GeoCoordinates',
    latitude: 36.66528,
    longitude: -93.26238,
  },
};
